import { Loading } from "./Loading"
import { NoDataSourceError } from "./NoDataSourceError"
import { Reading } from "./Reading"
import { StaleDataError } from "./StaleDataError"
import { useIsLoadingRecentGlucoseData } from "./useIsLoadingRecentGlucoseData"
import {
  useRecentReadings,
  useFollowedUsers,
} from "src/contexts"
import { useSources } from "src/hooks"

interface Props {
  userName: string;
}

export function UserHeaderData(props: Props) {
  const { userName } = props
  const { currentFollow } = useFollowedUsers()

  const { data: sources } = useSources()

  const {
    readings,
    initialized,
  } = useRecentReadings()
  const recentReading = readings[currentFollow.following_account_id]
  const isLoading = useIsLoadingRecentGlucoseData()

  if (currentFollow.is_self && sources?.length === 0) {
    return <NoDataSourceError userName={userName} />
  }

  if (recentReading) {
    return (
      <Reading
        accountId={currentFollow.following_account_id}
        userName={userName}
        reading={recentReading}
      />
    )
  }

  if (isLoading || !initialized) {
    return <Loading userName={userName} />
  }

  return (
    <StaleDataError
      userName={userName}
      accountId={currentFollow.following_account_id}
    />
  )
}
